import * as Sentry from '@sentry/browser';

const getSentryEnvironment = () => {
  switch (window.location.hostname) {
    case `${process.env.PRODUCTION}`:
      return 'production';
    default:
      if ((window.location.hostname.includes('ddev.site') === true)) {
        return 'local';
      } else {
        return 'unknown-environment';
      }
  }
}

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    allowUrls: [`${process.env.PRODUCTION}`],
    // Extend this list as needed, e.g. if the site runs some external scripts we don't have access to as they are not excluded by the above limitation
    // e.g. Google Tag Manager or Cooke Management Solutions, do exclude them here to prevent unsolvable issues being tracked
    denyUrls: [
      // Ignore noisy browser extensions:
      /extensions\//i,
      // Chrome/Chromium specific
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      // Safari specific
      /^safari-extension:\/\//i,
      // Firefox specific
      /^resource:\/\//i,
    ],
    dsn: `${process.env.SENTRY_BROWSER_PROJECT_DSN}`,
    environment: `${(getSentryEnvironment())}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Capture (valid) `console` events throughout the codebase /w sentry.
      // Limits messages to warnings, errors, debugs and traces, standard logs are NOT output for spamming reasons from other applications (browser apps, 3rd parties, ...)
      // Therefore: If we need to throw errors from JS do, preferable, throw them to Sentry using Sentry.captureException() (if it's not caught through the integrations below,
      // instead of just lazily console logging them (if not possible, at least use the suitable Console API function for errors).
      // See: https://docs.sentry.io/platforms/javascript/usage/#capturing-errors
      Sentry.captureConsoleIntegration({ levels: ['warn', 'error', 'debug', 'trace'] }),
      // Capture erroneous calls to the Fetch and XHR APIs.
      // See: https://docs.sentry.io/platforms/javascript/configuration/integrations/httpclient/
      Sentry.httpClientIntegration(),
      // Since we've, on occasion, inlined JavaScript in template files, we'll also add the ContextLines integration to cover these.
      // see: https://docs.sentry.io/platforms/javascript/configuration/integrations/contextlines/
      Sentry.contextLinesIntegration()
    ],
    release: `${process.env.SENTRY_RELEASE}`,
    // Limit Performance Tracing to Production environment (prevents spaming the Sentry `Performance` tab with result from dev/test environments.
    tracePropagationTargets: [`${process.env.PRODUCTION}`],
    tracesSampleRate: 1.0,
  });
}

